export default "__VITE_ASSET__CGF0nMZ3__"